import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiInstance } from '../../axiosApi';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export const auditTrendGet = createAsyncThunk(
  'auditor-dashboard/audit-trend-graph',
  async (params) => {
    return await apiInstance.get('/auditor-dashboard/audit-trend-graph', { params });
  }
);

export const auditorStatusGet = createAsyncThunk(
  'auditor-dashboard/audit-status',
  async (params) => {
    return await apiInstance.get('auditor-dashboard/audit-status', { params });
  }
);

export const auditStatusGraphGet = createAsyncThunk(
  'auditor-dashboard/audit-status-graph',
  async (params) => {
    return await apiInstance.get('/auditor-dashboard/audit-status-graph', { params });
  }
);

export const topFiveAuditorGet = createAsyncThunk(
  'auditor-dashboard/top-five-auditor',
  async (params) => {
    return await apiInstance.get('/auditor-dashboard/top-five-auditor', { params });
  }
);

export const lastFiveAuditorGet = createAsyncThunk(
  'auditor-dashboard/last-five-auditor',
  async (params) => {
    return await apiInstance.get('/auditor-dashboard/last-five-auditor', { params });
  }
);

const initialState = {
  auditTrendDetails: [],
  topFiveAuditorDetails: [],
  lastFiveAuditorDetails: [],
  auditStatusGraphDetails: { passed_audit: 0, failed_audit: 0 },
  auditorStatus: {
    total_audits: 0,
    passed_audit: 0,
    failed_audit: 0,
    pass_percentage: 0,
    pending_audit: 0,
    agents_audited: 0
  }
};

const auditorDashboardSlice = createSlice({
  name: 'auditorDashboard',
  initialState,
  reducers: {
    clearAuditorDashboardSlice: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(auditorStatusGet.fulfilled, (state, action) => {
      state.auditorStatus = action?.payload?.data;
    });
    builder.addCase(auditTrendGet.fulfilled, (state, action) => {
      state.auditTrendDetails = [...(action?.payload?.data || [])];
    });
    builder.addCase(auditStatusGraphGet.fulfilled, (state, action) => {
      state.auditStatusGraphDetails = action?.payload?.data;
    });
    builder.addCase(topFiveAuditorGet.fulfilled, (state, action) => {
      state.topFiveAuditorDetails = [...(action?.payload?.data || [])];
    });
    builder.addCase(lastFiveAuditorGet.fulfilled, (state, action) => {
      state.lastFiveAuditorDetails = [...(action?.payload?.data || [])];
    });
  }
});

export default auditorDashboardSlice.reducer;
export const { clearAuditorDashboardSlice } = auditorDashboardSlice.actions;

export const selectAuditTrendDetails = (state) => state.auditorDashboard.auditTrendDetails;
export const useAuditTrendDetails = () => {
  const auditTrendDetails = useSelector(selectAuditTrendDetails);
  return useMemo(() => auditTrendDetails, [auditTrendDetails]);
};

export const selectTopFiveAuditorDetails = (state) => state.auditorDashboard.topFiveAuditorDetails;
export const useTopFiveAuditorDetails = () => {
  const topFiveAuditorDetails = useSelector(selectTopFiveAuditorDetails);
  return useMemo(() => topFiveAuditorDetails, [topFiveAuditorDetails]);
};

export const selectLastFiveAuditorDetails = (state) =>
  state.auditorDashboard.lastFiveAuditorDetails;
export const useLastFiveAuditorDetails = () => {
  const lastFiveAuditorDetails = useSelector(selectLastFiveAuditorDetails);
  return useMemo(() => lastFiveAuditorDetails, [lastFiveAuditorDetails]);
};

export const selectAuditStatusGraphDetails = (state) =>
  state.auditorDashboard.auditStatusGraphDetails;
export const useAuditStatusGraphDetails = () => {
  const auditStatusGraphDetails = useSelector(selectAuditStatusGraphDetails);
  return useMemo(() => auditStatusGraphDetails, [auditStatusGraphDetails]);
};

export const selectAuditorStatus = (state) => state.auditorDashboard.auditorStatus;
export const useAuditorStatus = () => {
  const auditorStatus = useSelector(selectAuditorStatus);
  return useMemo(() => auditorStatus, [auditorStatus]);
};
